import { AUTHORIZATION_PREFIX, LOGINED, LOGIN_STATUS } from '@constants/common';
import { SET_TOKEN } from '@constants/store';
import store from '@store/index';
import axios from 'axios';
import { Message } from 'element-ui';
import qs from 'qs';
import Cookies from 'js-cookie';

const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。'
};

const _axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL2,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
        function (data, _headers) {
            // 对 data 进行任意转换处理
            return qs.stringify(data);
        }
    ]
});

_axios.interceptors.request.use(
    (config) => {
        const token = store.getters.token;
        const loginStatus = Cookies.get(LOGIN_STATUS);
        if (LOGINED === loginStatus && token) {
            config.headers.common['Authorization'] = AUTHORIZATION_PREFIX + token;
        }
        return config;
    },
    (error) => {
        const msg = error.message || error || '网络异常';
        Message.error(msg);
        return Promise.reject(new Error(error));
    }
);

_axios.interceptors.response.use(
    (res) => {
        // axios 会把响应头参数名转小写
        const token = res.headers['authorization'];
        if (token) {
            const reg = new RegExp(AUTHORIZATION_PREFIX, 'i');
            if (reg.test(token)) {
                store.commit(SET_TOKEN, token.substr(7));
            } else {
                store.commit(SET_TOKEN, token);
            }
        }
        const data = res.data;
        if (data.status !== 'success') {
            Message.error(data.message);
            return Promise.reject(new Error(data.message));
        }
        return Promise.resolve(data);
    },
    async (error) => {
        let msg = error.message || error || '网络异常';
        if (error.response) {
            const code = error.response.status;
            msg = codeMessage[code];
            if (code === 401) {
                store.dispatch('logout', true);
            }
        }
        Message.error(msg);
        return Promise.reject(new Error(error));
    }
);

export default _axios;
